import 'twin.macro';
import 'styled-components/macro';
import { gql } from '@apollo/client';
import { Link } from 'react-router-dom';

import { LoadingImage } from 'component-lib/atoms/LoadingImage/LoadingImage';
import { useRatingsContext } from 'toy/context/Ratings';
import { useSweetsQuery } from 'types/graphql-toy';

import { ButtonV2 } from '../../../component-lib/atoms/button-v2/ButtonV2';
import SweetList from '../../molecules/sweet-list/SweetList';

const SweetShop = () => {
  const { data, loading } = useSweetsQuery();
  const { getAverageRating } = useRatingsContext();

  const mergedData = data?.sweets?.map(sweet => {
    const reviewStats = getAverageRating(sweet.id);

    return {
      ...sweet,
      rating: reviewStats.average || 0,
      votes: reviewStats.reviews || 0,
    };
  });

  return (
    <>
      <div tw="flex justify-between">
        <h1 tw="display-1 mb-2">Sweets</h1>
        <Link to="/toy-shop/sweet/new">
          <ButtonV2>Add new sweet</ButtonV2>
        </Link>
      </div>

      {loading || !mergedData ? <LoadingImage /> : <SweetList sweets={mergedData} />}
    </>
  );
};

gql`
  query Sweets {
    sweets {
      id
      title
      created_at
      expires_at
    }
  }
`;

export default SweetShop;
